import useSkipToProfile from "@/features/auth/hooks/useSkipToProfile";
import { SignupEmailVerifyScreen } from "@/features/auth/screens/SignupEmailVerifyScreen";
import { verifyEmailOtpRouteSearchSchema } from "@/features/auth/search/authRouteSearch";
import { createFileRoute } from "@tanstack/react-router";

const VerifyEmail = () => {
    useSkipToProfile();
    const { email } = Route.useSearch();
    return <SignupEmailVerifyScreen email={email} />;
};

export const Route = createFileRoute("/_auth/verify")({
    component: VerifyEmail,
    validateSearch: (search) => verifyEmailOtpRouteSearchSchema.parse(search),
    beforeLoad: async ({ context: { auth } }) => {
        return auth;
    },
});
